(ns practitest.frontend.global-fields-settings.subs
  (:require
   [practitest.frontend.global-fields-settings.common :as global-fields-common]
   [practitest.frontend.global-fields-settings.utils :as global-field-utils]
   [practitest.frontend.global-fields-settings.events :as global-fields-events]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.common.format-utils :as fu]
   [clojure.string :as string]
   [re-frame.core  :as re-frame]))

(re-frame/reg-sub
  :global-fields-settings/init-complete?
  (fn [db _]
    (:init-complete? db)))

(re-frame/reg-sub
  :global-fields-settings/get-all-fields
  (fn [db _]
    (:global-fields db)))

(re-frame/reg-sub
  :global-fields-settings/list-field-names
  (fn [db _]
    (let [list-type #{"list" "linkedlist"}
          filtred-fields (filter #(list-type (:type %)) (:global-fields db))]
      (mapv :label filtred-fields))))

(re-frame/reg-sub
 :global-fields-settings/list-items
 (fn [db [_ list-name]]
   (let [{:keys [values type]} (first (filter #(= list-name (:label %)) (:global-fields db)))]
     (if (= type "linkedlist")
       (vec (distinct (apply concat (vals values))))
       values))))

(re-frame/reg-sub
  ::global-fields-form-data
  (fn [db _]
    (get-in db [:form-states2 global-fields-common/global-field-form-id :fields])))

(re-frame/reg-sub
 :global-fields-settings/form-loading?
 (fn [db _]
   (get-in db [:form-states2 global-fields-common/global-field-form-id :loading?] false)))

(re-frame/reg-sub
 ::global-field-id
 (fn [db _]
   (get-in db [:current-route :path-params :global-field-id])))

(re-frame/reg-sub
 ::global-fields-modal-data
 (fn [db _]
   (get-in db [:form-states2 global-fields-common/global-field-form-id :modal-data])))

(re-frame/reg-sub
 ::global-fields-show-modal
 (fn [db _]
   (get-in db [:form-states2 global-fields-common/global-field-form-id :modal-data :show])))

(re-frame/reg-sub
 ::global-fields-linkage-modal-data
 (fn [db _]
   (get-in db [:form-states2 global-fields-common/global-field-form-id :linkage-modal-data])))

(re-frame/reg-sub
 ::global-fields-show-linkage-modal
 (fn [db _]
   (get-in db [:form-states2 global-fields-common/global-field-form-id :linkage-modal-data :show])))

(def migration-wizard-form-id :global-fields-migration-wizard)

(re-frame/reg-sub
 ::migration-wizard-data
 (fn [db _]
   (get-in db [:form-states2 migration-wizard-form-id :wizard-data])))

(re-frame/reg-sub
 ::show-migration-wizard?
 (fn [db _]
   (get-in db [:form-states2 migration-wizard-form-id :wizard-data :show-wizard?])))

(re-frame/reg-sub
 ::selected-global-field
 (fn [db _]
   (get-in db [:form-states2 migration-wizard-form-id :fields :selected-global-field :value])))

(re-frame/reg-sub
 ::migratable-field-types
 (fn [db _]
   (set (map keyword (:migratable-field-types db)))))

(re-frame/reg-sub
 ::migration-wizard-project-fields
 (fn [db _]
   (get db :migration-wizard-project-fields [])))

(re-frame/reg-sub
 ::migration-wizard-project-fields-loading?
 (fn [db _]
   (get db :migration-wizard-project-fields-loading? false)))

(re-frame/reg-sub
 ::selected-project-fields
 (fn [db _]
   (get-in db [:form-states2 migration-wizard-form-id :wizard-data :selected-project-fields] [])))

(re-frame/reg-sub
 ::last-selected-global-field-id
 (fn [db _]
   (get-in db [:form-states2 migration-wizard-form-id :wizard-data :last-selected-global-field-id])))

(re-frame/reg-sub
 ::migration-wizard-project-fields-pagination
 (fn [db _]
   (get db :migration-wizard-project-fields-pagination {})))

(re-frame/reg-sub
 ::migration-entity-count
 (fn [db _]
   (get db :migration-entity-count 0)))

(re-frame/reg-sub
 ::migration-status
 (fn [db _]
   (get db :migration-status {:locked? false :field-name nil})))

;; Linked List Wizard subscriptions

(re-frame/reg-sub
 ::show-linked-list-wizard?
 (fn [db _]
   (get-in db [:linked-list-wizard :show?])))

(re-frame/reg-sub
 ::linked-list-wizard-data
 (fn [db _]
   (:linked-list-wizard db)))

(re-frame/reg-sub
 ::linked-list-wizard-filtered-fields
 (fn [db _]
   (let [linked-lists (get-in db [:linked-list-wizard :linked-lists] [])
         search-query (get-in db [:linked-list-wizard :search-query] "")]
     (if (string/blank? search-query)
       linked-lists
       (let [q (string/lower-case search-query)]
         (filter #(string/includes? (string/lower-case (:name %)) q) linked-lists))))))

(re-frame/reg-sub
 ::linked-list-wizard-selected-fields
 (fn [db _]
   (let [selected-ids (get-in db [:linked-list-wizard :selected-field-ids] #{})
         linked-lists (get-in db [:linked-list-wizard :linked-lists] [])]
     (filter #(contains? selected-ids (:id %)) linked-lists))))

(re-frame/reg-sub
 ::linked-list-wizard-can-continue?
 (fn [db _]
   (let [selected-ids (get-in db [:linked-list-wizard :selected-field-ids] #{})
         new-name (get-in db [:linked-list-wizard :new-global-name] "")]
     (and (seq selected-ids)
          (not (string/blank? new-name))))))

(re-frame/reg-sub
 ::linked-list-wizard-selected-project-ids
 (fn [db _]
   (let [selected-ids (get-in db [:linked-list-wizard :selected-field-ids] #{})
         linked-lists (get-in db [:linked-list-wizard :linked-lists] [])]
     (->> linked-lists
          (filter #(contains? selected-ids (:id %)))
          (map :project_id)
          set))))

(re-frame/reg-sub
 ::linked-list-import-in-progress?
 (fn [db _]
   (contains? (:progress db) ::global-fields-events/linked-list-import-progress)))

(re-frame/reg-sub
 ::linked-list-global-parent-options
 (fn [db _]
   (let [global-fields (:global-fields db)]
     (filter #(and (#{"list" "linkedlist"} (:type %)) (:has_linked_children %)) global-fields))))

;; Rename value modal

(re-frame/reg-sub
 ::rename-modal-data
 (fn [db _]
   (get-in db [:form-states2 global-fields-common/global-field-form-id :rename-modal])))

(re-frame/reg-sub
 ::rename-modal-show?
 (fn [db _]
   (get-in db [:form-states2 global-fields-common/global-field-form-id :rename-modal :show?] false)))

(re-frame/reg-sub
 ::rename-saving?
 (fn [db _]
   (contains? (:progress db) ::global-fields-events/rename-value-progress)))

(re-frame/reg-sub
 ::linked-list-wizard-union-values-count
 :<- [::linked-list-wizard-selected-fields]
 (fn [selected-fields _]
   (->> selected-fields
        (mapcat (fn [field]
                  (let [pv (:possible_values field)]
                    (if (map? pv)
                      (mapcat val pv)
                      []))))
        distinct
        count)))

(re-frame/reg-sub
  ::migratable-global-fields
  :<- [:global-fields-settings/get-all-fields]
  :<- [::migratable-field-types]
  (fn [[global-fields migratable-types] _]
    (filter #(contains? migratable-types (keyword (:field_format %)))
            global-fields)))

(defn- migration-wizard-on-add-value [_]
  (let [new-value (js/prompt (get-translation "global-fields.migration.enter-new-value" "Enter new field value"))
        validated-value (fu/validate-new-list-value! new-value)]
    (when validated-value
      (re-frame/dispatch [::global-fields-events/migration-add-value-to-global-field validated-value]))))

(re-frame/reg-sub
  ::migration-wizard-field-props
  :<- [::migratable-global-fields]
  :<- [::selected-global-field]
  :<- [::migration-wizard-data]
  (fn [[migratable-global-fields selected-global-field wizard-data] [_ field-name]]
    (let [selected-project-fields (or (:selected-project-fields wizard-data) [])]
      (cond
        (= field-name :selected-global-field)
        {:label (get-translation "global-fields.migration.select-global-field" "Select Global Field")
         :field-id :selected-global-field
         :field-name :selected-global-field
         :type :list
         :mandatory? true
         :edit-permissions? true
         :possible-values migratable-global-fields
         :label-fn (fn [field]
                     (if field
                       (str (:label (:id field)) " (" (global-fields-common/get-field-format-label (:field_format (:id field))) ")")
                       ""))
         :on-change (fn [new-value]
                      (re-frame/dispatch [::global-fields-events/migration-select-global-field new-value]))}

        (and (keyword? field-name)
             (string/starts-with? (name field-name) "value-mapping-"))
        (when selected-global-field
          (let [raw-values (or (:values selected-global-field) [])
                global-field-values (if (map? raw-values)
                                     (vec (distinct (mapcat val raw-values)))
                                     raw-values)
                selected-fields selected-project-fields
                all-project-values (global-field-utils/extract-field-values selected-fields)
                global-values-set (set global-field-values)
                filtered-project-values (filter #(not (contains? global-values-set %)) all-project-values)
                idx-str (second (string/split (name field-name) #"value-mapping-"))
                idx (js/parseInt idx-str 10)
                value-index-map (:value-index-map wizard-data)
                project-value (get value-index-map idx)]
            {:label ""
             :field-id field-name
             :field-name field-name
             :type :split-list
             :mandatory? false
             :edit-permissions? true
             :allow-add-list-value? (not= (:field_format selected-global-field) "linkedlist")
             :sections [{:id :global
                         :label (get-translation "global-fields.migration.existing-global-values" "Existing Values in Global Field")
                         :indicator (get-translation "global-fields.migration.existing-global-values-indication" "G")
                         :values global-field-values}
                        {:id :project
                         :label (get-translation "global-fields.migration.existing-project-values" "Existing Values in Project Field")
                         :indicator (get-translation "global-fields.migration.existing-project-values-indication" "P")
                         :values filtered-project-values}]
             :on-add-value-fn migration-wizard-on-add-value
             :on-change (fn [new-value]
                         (re-frame/dispatch [::global-fields-events/migration-map-value project-value new-value field-name]))
             :label-fn (fn [value]
                        (cond
                          (nil? value) ""
                          (map? value) (or (:label value) (:name value) (str value))
                          :else (str value)))}))

        :else nil))))

(re-frame/reg-sub
  ::linked-project-names
  (fn [db [_ field-id]]
    (get-in db [:linked-project-names field-id])))

(re-frame/reg-sub
  ::total-projects-count
  (fn [db _]
    (:total-projects-count db)))
